<template>
  <div>
    <label for="bookingStatusSelected"
      >Status<span v-if="required" class="required">*</span></label
    >
    <multiselect
      id="bookingStatusSelected"
      v-model="status"
      :options="statuses"
      label="text"
      track-by="id"
      :disabled="setDisable"
      style="margin: 0.6rem 0 0"
    >
    </multiselect>
  </div>
</template>

<script>
import BookingService from "services/api/booking.service";

export default {
  name: "BookingStatusDropdown",
  props: {
    value: { type: Object, default: null },
    isConfirmed: { type: Boolean, default: null },
    setDisable: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
  },
  data() {
    return {
      status: this.value,
      statuses: [],
    };
  },
  async created() {
    try {
      await this.getStatuses(this.isConfirmed);
    } catch (error) {
      console.log("Error during status initialization:", error);
    }
  },
  watch: {
    status(newValue) {
      this.$emit("setStatus", newValue);
    },
    value(newValue) {
      this.status = newValue;
    },
    statuses(newValue) {
      this.$emit("setStatuses", newValue);
    },
    isConfirmed(newValue) {
      this.getStatuses(newValue);
    },
  },
  methods: {
    async getStatuses(isConfirmed) {
      try {
        await BookingService.getStatuses()
          .then(async (res) => {
            let items = res.data.items;
            if (isConfirmed) items = items.filter((s) => s.key !== "BOOKED");
            this.statuses = items.map((s) => {
              return {
                id: s.key,
                text: s.value,
              };
            });
          })
          .catch((error) => {
            console.log("Error: ", error);
          });
      } catch (error) {
        console.log("Error: ", error);
      }
    },
  },
};
</script>
